export enum Roles {
  // eslint-disable-next-line no-unused-vars
  ADMIN = 'ADMIN',
  // eslint-disable-next-line no-unused-vars
  BAR = 'BAR',
  // eslint-disable-next-line no-unused-vars
  USER = 'USER',
}
